import { Component, Input } from '@angular/core';
import { FileDownloadDataServiceProvider } from '../../../../../shared/services/files/file-download-service/file-download.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'save-pdf-btn',
	template: require('./save-pdf-btn.html')
})
export class SavePdfBtnComponent {
	@Input() link: string;
	@Input() id: number;
	@Input() docType: string;

	isSpinnerActive: boolean;

	constructor(
		private fileDownloadDataService: FileDownloadDataServiceProvider,
		private messageService: MessageService
	) {}

	saveAsPdf(): void {
		this.isSpinnerActive = true;
		this.fileDownloadDataService
			.downloadPdf(this.link, this.id, this.docType)
			.then((): boolean => (this.isSpinnerActive = false))
			.catch(({ error }): void => {
				const { errorTitle, errorMessage } = error;
				this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				this.isSpinnerActive = false;
			});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/buttons/save-pdf-btn/save-pdf-btn.ts